// app/javascript/controllers/turnstile_controller.js

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    sitekey: String,
    theme: { type: String, default: "light" },
    size: { type: String, default: "flexible" },
  };

  connect() {
    if (typeof turnstile === "undefined") {
      this.loadScript();
    } else {
      this.renderTurnstile();
    }
  }

  loadScript() {
    const script = document.createElement("script");
    script.src =
      "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.onload = () => this.renderTurnstile();
    document.head.appendChild(script);
  }

  renderTurnstile() {
    turnstile.render(this.element, {
      sitekey: this.sitekeyValue,
      theme: this.themeValue,
      size: this.sizeValue,
    });
  }
}
